import api from './api';
import { EntityConfig } from '../types';

export const entityConfigApi = {
    getAllConfigs: async (page = 0, size = 10) => {
        const response = await api.get(`/admin/entity-configs?page=${page}&size=${size}`);
        return response.data;
    },

    getConfigByEntityId: async (entityId: string) => {
        const response = await api.get(`/admin/entity-configs/entity/${entityId}`);
        return response.data;
    },

    createConfig: async (config: Partial<EntityConfig>) => {
        const response = await api.post('/admin/entity-configs', config);
        return response.data;
    },

    updateConfig: async (id: string, config: Partial<EntityConfig>) => {
        const response = await api.put(`/admin/entity-configs/${id}`, config);
        return response.data;
    },

    deleteConfig: async (id: string) => {
        await api.delete(`/admin/entity-configs/${id}`);
    }
};
